import { useApiGet } from "./Api.hooks";

const endpoint = `/api/quotes`;

export const useGetQuotesPerWeek = () => {
  return useApiGet(`${endpoint}/quotes-per-week`);
};
